import React, { PureComponent } from 'react';
import NumberUtils from '../../utils/NumberUtils';
import PropTypes from 'prop-types';

class UntaggedPage extends PureComponent {
  static propTypes = {
    rowData: PropTypes.object,
    customClick: PropTypes.func,
    content: PropTypes.object,
  };
  onClick = () => {
    this.props.customClick(this.props.rowData.name, this.props.rowData);
  };
  render() {
    const {
      rowData: { current_month, name },
    } = this.props;
    const message =
      Number(current_month) === 0
        ? 'Great news, you have no untagged transactions.'
        : 'How about tagging these transactions?';
    return (
      <div className="transaction-row untagged" onClick={this.onClick}>
        <label>
          <span className="icon icon-tag" />
          {name}
        </label>
        <section>
          <p>Spent this month</p>
        </section>
        <section>
          <h5>{NumberUtils.appendCurrency('{}', current_month)}</h5>
        </section>
        <p className="untagged-message">{message}</p>
      </div>
    );
  }
}
export default UntaggedPage;
